// extracted by mini-css-extract-plugin
module.exports = {"container":"Complete_container__AGOI9"};